import React from "react";
import { BrowserRouter as Router, Route, Routes, Navigate } from "react-router-dom";
import { TranslationProvider } from "./Context/TranslationContext";
import { ParallaxProvider } from 'react-scroll-parallax';
import { AuthProvider } from "./components/Navbar";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import AwardsPage from "./Pages/Awards";
import AwardsAndDecorationsPage from "./Pages/AwardsAndDecorations";
import ScrollToTop from "./components/scrolltotop";
import StateTrainingCenters from "./Pages/StateCenter";

// Components
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";

// Pages
import ScoutHomepage from "./Pages/ScoutHomePage";
import WhoWeAre from "./Pages/WhoWeAre";
import ScoutEducation from "./Pages/ScoutEducation";
import ScoutMethod from "./Pages/ScoutMethod";
import ScoutPromiseLaw from "./Pages/ScoutPromiseAndLaw";
import WhatWeDo from "./Pages/WhatWeDo";
import Gallery from "./Pages/Gallery";
import WhereWeWork from "./Pages/WhereWeWork";
import GetInvolved from "./Pages/GetInvolved";
import Products from "./Pages/Products";
import LoginPage from "./Pages/Login";
import ScoutingHistoryPage from "./Pages/ScoutingHistory";
import DonationPage from "./Pages/DonationPage";
import DonationPayment from "./Pages/DonationPayment";
import Cart from "./Pages/Cart";
import ProductDescription from "./Pages/ProductDescription";
import OfficeBearersPage from "./Pages/OfficeBearers";
import CheckoutPage from "./Pages/CheckoutPage";
import OrderSuccessPage from "./Pages/OrderSucessPage";
import OrdersPage from "./Pages/Order";
import MyProfile from "./Pages/MyProfile";
import YourAddress from "./Pages/YourAddresses";
import ProgramsPage from "./Pages/programs";
import JamboreePage from "./Pages/Jamboree";
import ContactPage from "./Pages/Contact";
import BunnyProgram from "./Pages/bunny";
import CubsSection from "./Pages/cub";
import BulbulSection from "./Pages/bulbul";
import ScoutSection from "./Pages/scout";
import GuideSection from "./Pages/guide";
import RangerSection from "./Pages/ranger";
import RoverSection from "./Pages/rover";
import DistrictTrainingCenters from "./Pages/DistrictCenters";
import GoldenArrowPage from "./Pages/goldenarrow";
import RashtrapatiBadgePage from "./Pages/rashtrapathiaward";
import RajyapuraskarPage from "./Pages/rajyapuraskar";


// Protected Route Component
const ProtectedRoute = ({ children }) => {
  const isAuthenticated = localStorage.getItem('auth-storage') !== null;
  
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }
  return children;
};

// Admin Route Handler - Updated to handle admin routes properly
const AdminRouteHandler = () => {
  const currentPath = window.location.pathname;
  
  // Only redirect if we're not already on the admin path
  if (!currentPath.includes('/admin/login')) {
    window.location.href = '/admin/login';
  }
  return null;
};

function App() {
  return (
    <AuthProvider>
      <Router>
        <ScrollToTop/>
        <ParallaxProvider>
          <TranslationProvider>
            <ToastContainer
              position="top-right"
              autoClose={3000}
              hideProgressBar={false}
              newestOnTop
              closeOnClick
              rtl={false}
              pauseOnFocusLoss
              draggable
              pauseOnHover
            />
            
            <Navbar />
            
            <Routes>
              {/* Public Routes */}
              <Route path="/" element={<ScoutHomepage />} />
              <Route path="/ScoutHomepage" element={<ScoutHomepage />} />
              <Route path="/whoweare" element={<WhoWeAre />} />
              <Route path="/scout-education" element={<ScoutEducation />} />
              <Route path="/scout-method" element={<ScoutMethod />} />
              <Route path="/scout-promising-law" element={<ScoutPromiseLaw />} />
              <Route path="/what-we-do" element={<WhatWeDo />} />
              <Route path="/where-we-work" element={<WhereWeWork />} />
              <Route path="/get-involved" element={<GetInvolved />} />
              <Route path="/gallery" element={<Gallery />} />
              <Route path="/scouting-history" element={<ScoutingHistoryPage />} />
              <Route path="/office-bearers" element={<OfficeBearersPage />} />
              <Route path="/product" element={<Products />} />
              <Route path="/product-description" element={<ProductDescription />} />
              <Route path="/login" element={<LoginPage />} />
              <Route path="/donation" element={<DonationPage />} />
              <Route path="/donate/:eventId" element={<DonationPayment />} />
              <Route path="/address" element={<YourAddress />} />
              <Route path="/programs" element={<ProgramsPage/>} />
              <Route path="/contact" element={<ContactPage/>} />
              <Route path="/jamboree" element={<JamboreePage/>} />
              <Route path="/awards" element={<AwardsPage />} />
              <Route path="/awards-and-decorations" element={<AwardsAndDecorationsPage />} />
              <Route path="/bunny" element={<BunnyProgram/>}/>
              <Route path="/cubs" element={<CubsSection/>}/>
              <Route path="/bulbuls" element={<BulbulSection/>}/>
              <Route path="/scouts" element={<ScoutSection/>}/>
              <Route path="/guide" element={<GuideSection/>}/>
              <Route path="/ranger" element={<RangerSection/>}/>
              <Route path="/rover" element={<RoverSection/>}/>
              <Route path="/state-training-center" element={<StateTrainingCenters/>}/>
              <Route path="/district-training-center" element={<DistrictTrainingCenters/>}/>
              <Route path="/goldenarrow" element={<GoldenArrowPage/>}/>
              <Route path="/rastrapatipuraskar" element={<RashtrapatiBadgePage/>}/>
              <Route path="/rajyapuraskar" element={<RajyapuraskarPage/>}/>






              
              

              {/* Protected Routes */}
              <Route
                path="/cart"
                element={
                  <ProtectedRoute>
                    <Cart />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/checkout"
                element={
                  <ProtectedRoute>
                    <CheckoutPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/order-success"
                element={
                  <ProtectedRoute>
                    <OrderSuccessPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/orders"
                element={
                  <ProtectedRoute>
                    <OrdersPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/profile"
                element={
                  <ProtectedRoute>
                    <MyProfile />
                  </ProtectedRoute>
                }
              />

              {/* Admin Routes - Redirect to Admin App */}
              <Route path="/admin/*" element={<AdminRouteHandler />} />

              {/* Catch all route - redirect to home */}
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
            
            <Footer />
          </TranslationProvider>
        </ParallaxProvider>
      </Router>
    </AuthProvider>
  );
}

export default App;